import { Injectable, signal } from '@angular/core';
import { BRANDINGS, DEFAULT_BRANDING } from '../branding-config/branding.config';
import { normalizeTenantKey } from '../branding-config/tenant-features';
import { BrandingConfig } from '../../api/app-types/branding-config.app';

@Injectable({
	providedIn: 'root',
})
export class BrandingService {
	public readonly branding = signal<BrandingConfig>(DEFAULT_BRANDING);

	public setTenant(tenantName: string) {
		const tenantKey = normalizeTenantKey(tenantName);
		const config = tenantKey ? (BRANDINGS[tenantKey] ?? DEFAULT_BRANDING) : DEFAULT_BRANDING;

		this.branding.set(config);
		this.updateFavicon(config.favicon);
	}

	private updateFavicon(path: string) {
		let link = document.querySelector("link[rel*='icon']") as HTMLLinkElement;

		if (!link) {
			link = document.createElement('link');
			link.rel = 'icon';
			document.head.appendChild(link);
		}

		link.type = 'image/x-icon';
		link.href = path;
	}
}
